import React, { useMemo } from 'react';

import { FilterData } from './filter';

export const useFilter = <T extends object, F extends string>(
  items: T[],
  getFilterOptions: (items: T[], filterData?: FilterData<F>) => FilterData<F>,
  filterItems: (items: T[], filter: FilterData<F>) => T[],
  getTranslation: (count: number) => string,
  tabFilter?: (item: T, index: number, all: T[]) => boolean,
) => {
  const [filterSelectedData, setFilterSelectedData] = React.useState<
    FilterData<F>
  >(getFilterOptions(items));

  const [filterCountTranslation, setFilterCountTranslation] =
    React.useState<string>(getTranslation(items.length));

  const filteredItems = useMemo(
    () => filterItems(items, filterSelectedData),
    [items, filterSelectedData, filterItems],
  );

  return {
    filteredItems,
    filterProps: {
      filterOptions: getFilterOptions(
        filterItems(
          items.filter((...args) => !tabFilter || tabFilter(...args)),
          filterSelectedData,
        ),
        filterSelectedData,
      ),
      filteredItemsCountTranslation: filterCountTranslation,
      onFilterChange: (data: FilterData<F>) => {
        const filteredPreviewItems = filterItems(items, data);
        setFilterCountTranslation(getTranslation(filteredPreviewItems.length));
        setFilterSelectedData(data);
      },
    },
    selectedFilters: filterSelectedData,
  };
};
